import React from "react";
import { withStyles } from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { isCurrentUserAdmin, canBeEdited } from "../utils/userRoles";

const styles = theme => ({
  root: {
    bottom: theme.spacing(1)
  },
  darkBg: {
    backgroundColor: theme.palette.background.default
  },
  button: {
    marginLeft: theme.spacing(1),
    textTransform: "none"
  },
  divider: {
    color: theme.palette.primary.main
  }
});

export const NewDialogTitle = withStyles(styles)(
  ({
    children,
    classes,
    onCancel,
    onSave,
    saveAvaliable,
    showSaveButton,
    onEdit,
    onDelete,
    doNotDelete,
    darkBg,
    organizationRef,
    caption = "Change a value to start editting",
    globalAccess = false,
    onDeviceComandsClick
  }) =>
    <MuiDialogTitle
      disableTypography
      className={`${classes.root}, ${darkBg ? classes.darkBg : ""}`}
    >
      <Grid container justify="space-between">
        <Grid item>
          <Typography variant="h6">
            <b>{children}</b>
          </Typography>
        </Grid>
        <Grid item>
          {!showSaveButton && <Typography variant="caption">{caption}</Typography>}
          {onDeviceComandsClick && (
            <Button
              aria-label="Commands"
              variant="contained"
              onClick={onDeviceComandsClick}
              className={classes.button}
            >
              Commands
            </Button>
          )}
          {onDelete &&
            isCurrentUserAdmin() &&
            !doNotDelete &&
            canBeEdited(organizationRef, globalAccess) && (
              <Button
                aria-label="Delete"
                color="secondary"
                variant="contained"
                className={classes.button}
                onClick={onDelete}
              >
                Delete
              </Button>
            )}
          {onCancel && (
            <Button
              aria-label="Cancel"
              variant="contained"
              onClick={onCancel}
              className={classes.button}
            >
              {saveAvaliable ? 'Cancel' : 'Close'}
            </Button>
          )}
          {onSave && showSaveButton && (
            <Button
              aria-label="Save"
              variant="contained"
              color="primary"
              onClick={onSave}
              className={classes.button}
              disabled={!saveAvaliable}
            >
              Save Changes
            </Button>
          )}
          {onEdit && isCurrentUserAdmin() && canBeEdited(organizationRef, globalAccess) && (
            <Button
              aria-label="Edit"
              color="primary"
              variant="contained"
              className={classes.button}
              onClick={onEdit}
            >
              Edit
            </Button>
          )}
        </Grid>
      </Grid>
      <hr className={classes.divider} />
    </MuiDialogTitle>
)
